import { atom, selector } from "recoil";

export const investmentUnreadCount = atom<{ unread_count: number }>({
  key: "investmentUnreadCount",
  default: null,
});

export const assessmentUnreadCount = atom<{ unread_count: number }>({
  key: "assessmentUnreadCount",
  default: null,
});

export const hasUnread = selector({
  key: "hasUnread",
  get: ({ get }) => {
    const investmentUnread = get(investmentUnreadCount);
    return investmentUnread?.unread_count > 0;
  },
});

// 受信箱に表示する投資メッセージだけをナビゲーションの件数に使う。
// 査定atomは既存の詳細・APIとの互換性のため残す。
export const proposalUnreadCount = selector<number>({
  key: "proposalUnreadCount",
  get: ({ get }) => Math.max(0, get(investmentUnreadCount)?.unread_count ?? 0),
});
